import { preference, user } from '@fuselab/ui-fabric/lib/reducers';
import { combineReducers } from 'redux';
import { Store } from '../store';
import error from './error';
import files from './files';
import orderDetail from './order';
import orders from './orderList';
import imagePreviews from './preview';
import review from './review';
import reviews from './reviewList';

export default combineReducers<Store>({
  user,
  preference,
  imagePreviews,
  orders,
  orderDetail,
  review,
  reviews,
  error,
  files,
  token: state => state || null,
  loginHostName: state => state || null
});
